export default __webpack_public_path__ + "fonts/ArgoRegular.TTF";